// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "大学英语（一）",
      "tec": "王立野",
      "week": "6-17周",
      "add": "实训楼E座302语音室"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[03-04节]）"
    },
    {
      "sub": "高等数学（一）",
      "tec": "杨宇",
      "week": "6-17周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "6-9周",
      "add": "教学楼C座210教务"
    }
  ],
  "2": [
    {
      "sub": "人工智能与计算思维",
      "tec": "吴赜书",
      "week": "6-16周",
      "add": "教学楼D座513能动AISEC"
    },
    {
      "sub": "思想道德与法治",
      "tec": "马月",
      "week": "6-17周",
      "add": "教学楼A座119信息"
    },
    {
      "sub": "明辨性思维",
      "tec": "王淑慧",
      "week": "6-13周",
      "add": "教学楼D座424能动AISEC"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "军事理论",
      "tec": "秦剑",
      "week": "6-14周",
      "add": "教学楼D座514能动AISEC"
    },
    {
      "sub": "高等数学（一）",
      "tec": "杨宇",
      "week": "6-17周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "思想道德与法治",
      "tec": "马月",
      "week": "6-17周",
      "add": "教学楼A座426机械"
    },
    {
      "sub": "大学英语（一）",
      "tec": "王立野",
      "week": "6-17周",
      "add": "实训楼F座203自控"
    },
    {
      "sub": "心理健康与调适",
      "tec": "李婵",
      "week": "6-15周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "高等数学（一）",
      "tec": "杨宇",
      "week": "6-17周",
      "add": "教学楼D座513能动AISEC"
    },
    {
      "sub": "动力工程导论",
      "tec": "高宇",
      "week": "6-17周",
      "add": "教学楼B座317能动"
    },
    {
      "sub": "人工智能与计算思维",
      "tec": "吴赜书",
      "week": "6,8,10,12,14周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
